import * as semver from 'semver';

/**
 * Utility class for version comparison using semver
 */
class VersionUtils {
  public extensionMinVersion = '6.9.0';
  public optInBucketsMinVersion = '7.1.0';
  /**
   * Checks if the version is at least the target version
   * @param version - The version to check
   * @param target - The target version to compare against
   * @returns true if version is greater than or equal to target
   */
  public isAtLeast(version: string, target: string): boolean {
    return semver.gte(version, target);
  }

  /**
   * Checks if the version is greater than the target version
   * @param version - The version to check
   * @param target - The target version to compare against
   * @returns true if version is greater than target
   */
  public isGreaterThan(version: string, target: string): boolean {
    return semver.gt(version, target);
  }

  /**
   * Checks if the version is less than the target version
   * @param version - The version to check
   * @param target - The target version to compare against
   * @returns true if version is less than target
   */
  public isLessThan(version: string, target: string): boolean {
    return semver.lt(version, target);
  }

  public supportsBucketsOptIn(extensionVersion: string): boolean {
    return (
      semver.valid(extensionVersion) !== null &&
      this.isAtLeast(extensionVersion, this.optInBucketsMinVersion)
    );
  }
}

export const versionUtils = new VersionUtils();
